import HTTPClient from './http-client';

// Override `maxAge` and cache URLs with query parameters
const options = {
    cache: {
        maxAge: 60 * 60 * 1000,  // 1 hour instead of 24 hours
        exclude: { query: false },
    }
};

const loadFeatures = async (urlGeojson) => {    
    const httpClient = new HTTPClient();
    const URL = urlGeojson;
    const api = await httpClient.configure();

    return api.get(
        `${URL}`,
        options
    );
};

export {
    loadFeatures
}